import {getDataInLocalStorage, saveDataToLocalStorage} from "./localStorage";

export function isVersion(sysUiVersion){
    const localVersion = getDataInLocalStorage('version');
    if (!localVersion || (localVersion && localVersion !== sysUiVersion)) {
        saveDataToLocalStorage('version', sysUiVersion);
        window.location.reload();
    }
}
